
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-platform",
      function () {
        return require("private-next-pages/open-platform/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-platform"])
      });
    }
  